import React, {useState,useEffect} from 'react';

const leds=()=>{
 return(
    <div className="App">
     <div className="led-main">LEDs</div>
    </div>
    )
}
export default leds;